import { useEffect, useState } from 'react'

import { Box, Button, Input, Modal, Text } from '@fairfashion/design-system'
import { useForm } from 'react-hook-form'

import { IZipcodeResponseDTO } from '../../sdk/providers/providers.types'
import { sdk } from '../../services/sdk'

import {
  CompanyAddressForm,
  EditCompanyAddressModalProps,
} from './edit-company-address-modal.types'

export const EditCompanyAddressModal = ({
  data,
  open,
  onClose,
  onSubmit,
}: EditCompanyAddressModalProps) => {
  const [fetchedZipcode, setFetchedZipcode] = useState(false)
  const [zipCodeFound, setZipcodeFound] = useState(false)
  const [zipCodeResponse, setZipcodeResponse] = useState<IZipcodeResponseDTO>()

  const { register, reset, handleSubmit } = useForm<CompanyAddressForm>()

  useEffect(() => {
    if (data) {
      reset({
        zipCode: data.zipCode ? data.zipCode.replace(/\D/g, '') : '',
        city: data.city,
        state: data.state,
        country: data.country,
        street: data.street,
        number: data.number,
        district: data.district,
      })
    }
  }, [data])

  const submitForm = async (data: CompanyAddressForm) => {
    if (onSubmit) {
      await onSubmit(data)
      onClose()
    }
  }

  const fetchZipcode = async (code: string) => {
    if (code?.length === 8) {
      try {
        const response = await sdk.providers.getZipcode(code)
        reset({
          ...response,
          district: response.neighborhood,
          country: 'Brasil',
        })
        setZipcodeFound(true)
        setZipcodeResponse(response)
      } catch (err) {
        setZipcodeResponse(undefined)
        setZipcodeFound(false)
      } finally {
        setFetchedZipcode(true)
      }
    } else {
      setFetchedZipcode(false)
    }
  }

  const disableFields = fetchedZipcode && zipCodeFound

  return (
    <Modal
      open={open}
      onClose={onClose}
      title="Editar Localização"
      width="830px"
      maxWidth="90%"
    >
      {open && (
        <form onSubmit={handleSubmit(submitForm)}>
          <Box width="100%" direction="column" gap={2}>
            <Text size="small" fontWeight={500}>
              Endereço
            </Text>

            <Box width="100%" flexWrap="wrap" gap={2} marginTop={1}>
              <Box flex={1} minWidth="120px">
                <Input
                  {...register('zipCode')}
                  label="CEP"
                  onChange={(e) => fetchZipcode(e.target.value)}
                />
              </Box>
              <Box flex={1} minWidth="120px">
                <Input
                  {...register('city')}
                  disabled={disableFields}
                  label="Cidade"
                />
              </Box>
              <Box flex={1} minWidth="120px">
                <Input
                  {...register('state')}
                  disabled={disableFields}
                  label="Estado"
                />
              </Box>
              <Box flex={1} minWidth="120px">
                <Input
                  {...register('country')}
                  disabled={disableFields}
                  label="País"
                />
              </Box>
            </Box>

            <Box width="100%" flexWrap="wrap" gap={2}>
              <Box flex={2} minWidth="120px">
                <Input
                  {...register('street')}
                  disabled={
                    zipCodeResponse
                      ? disableFields && !!zipCodeResponse?.street
                      : disableFields
                  }
                  label="Logradouro"
                />
              </Box>
              <Box flex={1} minWidth="120px">
                <Input {...register('number')} label="Nº" />
              </Box>
              <Box flex={1} minWidth="120px">
                <Input
                  {...register('district')}
                  disabled={
                    zipCodeResponse
                      ? disableFields && !!zipCodeResponse?.neighborhood
                      : disableFields
                  }
                  label="Bairro"
                />
              </Box>
            </Box>

            <Box width="100%" justifyContent="flex-end" gap={2}>
              <Button variant="outlined" onClick={onClose}>
                Cancelar
              </Button>
              <Button type="submit">Salvar</Button>
            </Box>
          </Box>
        </form>
      )}
    </Modal>
  )
}
